import { render } from "./AnalyticsPage.vue?vue&type=template&id=053e1e1a"
import script from "./AnalyticsPage.vue?vue&type=script&lang=js"
export * from "./AnalyticsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__